angular.module('mercury.modules.reports.voids')
.factory('PosVoids', ["$http", "$q", "$resource", "settings", function($http, $q, $resource, settings) {
  var VoidsByReason = $resource(settings.mercHost + '/pos/voids/by-reason');

  function getByInterval(start, end, interval, companyId) {
    var deferred = $q.defer();
    var config = {params: {start: start, end: end, interval: interval}};

    // Optionally override the company-id header
    if (companyId) {
      config.headers = {
        'x-loaded-company-id': companyId,
        'x-loaded-suppress-subscription-errors': '1'
      };
    }

    $http.get(settings.mercHost + '/pos/voids', config)
    .then(function(response) {
      deferred.resolve(response.data);
    }, function(response) {
      deferred.reject(response);
    });
    return deferred.promise;
  }

  function getByReason(start, end) {
    return VoidsByReason.query({start: start, end: end}).$promise;
  }

  return {
    getByInterval: getByInterval,
    getByReason: getByReason
  };
}]);
